<div class="button-container">
    <kendo-buttongroup>
        <button kendoButton [ngClass]="{'toggled': isSectionVisible(tab.tabTitle)}" [toggleable]="true" *ngFor="let tab of pageData?.pageTabs" (click)="toggleSection(tab.tabTitle)">
            {{ tab.tabTitle | transloco }}
        </button>
        <button kendoButton (click)="printPDF()" style="margin-left: 10px" [svgIcon]="downloadIcon">Stampa PDF</button>
    </kendo-buttongroup>
</div>

<div class="print-container" #printSection style="width: 100% !important; flex-direction: column !important">
    <div class="drk-page-wrapper">
        <div *ngFor="let tab of pageData?.pageTabs">
            <div *ngIf="isSectionVisible(tab.tabTitle)" class="section">
                <h2 style="margin-left: 23px;">{{ tab.tabTitle | transloco }}</h2>
                <div class="drk-tab-content">
                    <div class="drk-component full-width" *ngFor="let c of tab.tabComponents">
                        <div class="bg-card mt-2 overflow-hidden flex-w-full p-4 shadow">
                            <app-drake-custom-component [config]="c" [baseData]="baseData" [readonly]="true"></app-drake-custom-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
